import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RegisterForm from "./Register";
import LoginForm from "./LoginButton";
import Dashboard from "./dashboard";
// 1. Capitalize the imported name here
import UserDashboard from "./UserDashboard" 


function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<RegisterForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* 2. Capitalize the component name here */}
          <Route path="/userDashboard" element={<UserDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;